import React from "react";
import { Phone, MapPin, Clock } from "lucide-react";
import { clinic, hours } from "../data";

export default function Header({ onCtaClick }) {
  return (
    <header className="site-header" data-testid="site-header">
      <div className="container header-row">
        <div className="header-info" data-testid="header-info">
          <div className="header-info-item">
            <MapPin size={16} />
            <div>
              <div className="hii-title">{clinic.address}</div>
              <div className="hii-sub">{clinic.city}</div>
            </div>
          </div>
          <div className="header-info-item">
            <Clock size={16} />
            <div>
              <div className="hii-title">{hours[0].days} {hours[0].time}</div>
              <div className="hii-sub">{hours[1].days} {hours[1].time}</div>
            </div>
          </div>
        </div>

        <div className="header-cta">
          <a href={`tel:${clinic.phoneRaw}`} className="header-phone" data-testid="header-phone">
            <Phone size={16} />
            <span>{clinic.phone}</span>
          </a>
          <button
            className="btn btn-teal header-cta-btn"
            onClick={onCtaClick}
            data-testid="header-cta-btn"
          >
            Записаться
          </button>
        </div>
      </div>

      {/* Компактная полоска контактов для мобильной */}
      <div className="header-mobile-contacts container" data-testid="header-mobile-contacts">
        <div className="hmc-item">
          <MapPin size={14} />
          <span>{clinic.address}, {clinic.city}</span>
        </div>
        <a
          href={`tel:${clinic.phoneRaw}`}
          className="hmc-item hmc-phone"
          data-testid="header-mobile-phone"
        >
          <Phone size={14} />
          <span>{clinic.phone}</span>
        </a>
      </div>
    </header>
  );
}
